const initialState: any = {
  south: -75.93489090881157,
  west: -169.64263916015625,
  north: 81.30499982340113,
  east: 190.54687500000003
}
export default (state = initialState, action) => {
  switch (action.type) {
    case 'set_map_bounds':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
